export default "__VITE_ASSET__moWbF1iy__"